// modules
import React, {useEffect, useState} from 'react';

// local
import './ValueProp.css';


const ValueProp = () => {
  const [timer, setTimer] = useState(5)

  useEffect(() => {
    this.myInterval = setInterval(() => {
      setTimer(timer - 1)
    }, 1100)
    if (timer === 0) {
      window.location.href = "https://www.momentumtradingjournal.com";
    }
  }, [timer])

  return (
    <div className={ 'ValueProp__wrapper' }>
      <h1 className={ 'ValueProp__title' }>
        { 'We launched! ' }
      </h1>
      <p className={ 'ValueProp__text' }>
        {`Redirecting you in ${timer} to `}<a href="https://wwww.momentumtradingjournal.com">momentumtradingjournal.com</a>
      </p>
      <br/>
      <br/>
      <h1 className={ 'ValueProp__title' }>
        { 'We\'re overdue for some ' }
        <span className={ 'ValueProp__highlight' }>{ 'better tools.' }</span>
      </h1>
      <p className={ 'ValueProp__text' }>
        {
          'Designed for day-traders who are serious about self ' +
          'improvement. Momentum replaces post-it notes and homemade ' +
          'spreadsheets with a clean, modern trading journal that ' +
          'streamlines the tasks that make us better traders.'
        }
      </p>
    </div>
  );
}

export default ValueProp;



// WEBPACK FOOTER //
// ./src/components/ValueProp/index.js